import { Navigate } from "react-router-dom";
import * as React from "react";
import { useContext } from "react";
import { AuthContext } from "../contexts/auth-context";

export const Redirect404 = ({ toAuthenticated, toNonAuthenticated }) => {
  const { isInitialized, isAuthenticated } = useContext(AuthContext);
  if (!isInitialized) {
    return null;
  }
  return (
    <Navigate
      to={isAuthenticated ? toAuthenticated : toNonAuthenticated}
      replace={true}
    />
  );
};
